import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import type {SourceAssetPrice} from '../../../../packages/sdk/src';
import {candidates} from '../lib/assetCatalog';
import {money} from '../lib/api';
import {useData} from '../lib/data';

export function SourcePriceTicker() {
    const feed = useData<{quotes:SourceAssetPrice[]}>('/prices/source-assets', 30000);
    const [now, setNow] = useState(Date.now);
    useEffect(() => { const timer = window.setInterval(() => setNow(Date.now()), 1000); return () => window.clearInterval(timer); }, []);
    return <nav className="source-price-ticker" aria-label="Receipt source reference prices">
        <span className="source-price-label">RECEIPT PRICES <small>SOURCE REF · USD · 24H</small></span>
        <div className="source-price-scroll">
            {candidates.map(asset => {
                const quote = feed.data?.quotes.find(row => row.name === asset.name);
                const fresh = quote && quote.validUntil > now;
                const change = fresh ? quote.change24h : null;
                const status = quote ? 'Stale' : feed.loading ? 'Loading' : 'Unavailable';
                return <Link key={asset.id} to={`/assets/${asset.id}`} className="source-price-item"
                    title={quote ? `${asset.name} PreStocks · Solana mainnet · USD per source token. DEX Screener fetched ${new Date(quote.fetchedAt).toLocaleTimeString()}. ${fresh ? 'Reference price; execution may differ.' : 'Feed expired.'}` : `${asset.name}: ${status.toLowerCase()}`}>
                    <strong>{asset.name}</strong><span className="source-price-value">{fresh ? money(quote.usd) : status}</span>
                    <span className={change === null || change === 0 ? 'source-change' : change > 0 ? 'source-change up' : 'source-change down'}
                        aria-label={change === null ? '24-hour change unavailable' : `24-hour change ${change > 0 ? '+' : ''}${change}%`}>
                        {change === null ? '—' : `${change > 0 ? '▲' : change < 0 ? '▼' : ''} ${Math.abs(change).toFixed(2)}%`}
                    </span>
                </Link>;
            })}
        </div>
        <a className="source-price-provider" href="https://dexscreener.com/solana" target="_blank" rel="noreferrer" title="DEX Screener reference prices · refreshes every 30 seconds · USD per PreStocks token">DEX Screener ↗</a>
    </nav>;
}
